import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const pointsHeadingStyling: AbgSxProps = {
  mb: 2,
  boxShadow: 'none',
};
export const accordionSummaryStyling: AbgSxProps = {
  padding: { sm: '0px 24px 0px 24px', xs: '0px' },
  minHeight: 0,
  '&.Mui-expanded': { minHeight: 0 },
};

export const modifyAccordionSummaryStyling: AbgSxProps = {
  ...accordionSummaryStyling,
  padding: '0px',
};
export const accordionBoxStyling: AbgSxProps = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
export const accordionDetailsStyling: AbgSxProps = {
  padding: { sm: '0px 24px 24px 24px', xs: '0px 0px 20px 0px' },
};

export const modifyAccordionDetailsStyling: AbgSxProps = {
  ...accordionDetailsStyling,
  padding: '0px',
};
export const greyTextPoints: AbgSxProps = {
  color: paletteBase.neutral400,
};

export const greenTextPoints: AbgSxProps = {
  color: paletteBase.semanticGreen,
  order: {
    sm: 1,
    xs: 2,
  },
  textAlign: {
    xs: 'right',
    sm: 'left',
  },
};

export const redTextPoints: AbgSxProps = {
  color: paletteBase.red500,
};

export const iconStyles: AbgSxProps = { fontSize: 24 };

export const pointsLineItemsStyling: AbgSxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
